import React ,{useState, useEffect, useMemo, useRef} from 'react'
import { useLocation } from 'react-router-dom';
import './AllProducts.css'
import { useListAllQuery, useListForHomeQuery } from '../../api/product.api'
import AllProductItem from '../../common/AllProductItem/AllProductItem'
import LoadingComponent from '../../common/Loading/Loading.component'
import { mediaPreloader } from "../../utils/preloader";
import line_svg from "../../assets/images/headline-curve.svg";
import SectionHeading from '../../common/SectionHeading/SectionHeading';

const AllProducts = () => {
    const location = useLocation();
    const [search, setSearch] = useState('');
    const [assetsLoaded, setAssetsLoaded] = useState(false);
    const productRef = useRef(null) 
    
    // Update search whenever location changes (from Navbar search or direct navigation)
    useEffect(() => {
      // If navigating with a search query, update it
      if (location.state?.searchQuery !== undefined) {
        setSearch(location.state.searchQuery);
      } 
      // If navigating without search query (e.g., clicking "All Products" menu), clear it
      else if (location.state === null || (location.state && !location.state.searchQuery)) {
        setSearch('');
      }
    }, [location]);

    // RTK Query will automatically refetch when search param changes
    const {data, error, isLoading}  = useListAllQuery({search}, {
      refetchOnMountOrArgChange: true,
      skip: false,
    });
    
    
    
    const product = useMemo(() => {
      return data?.result || [];
    }, [data]);

    
    // Advanced preloading with batch processing
    useEffect(() => {
        if (product.length > 0 && !assetsLoaded) {
          const preloadAssets = async () => {
            try {
              const assets = [];
              product.forEach(item => {
                assets.push(
                  { type: item.media?.[0]?.type, src: item.media?.[0]?.url, priority: 'high' }
                );
              });  
              // Batch preload all assets
              await mediaPreloader.batchPreload(assets);
              setAssetsLoaded(true);
            } catch (error) {
              setAssetsLoaded(true); // Still show content even if preload fails
            }
          };
    
          preloadAssets();
        }
    }, [product, assetsLoaded]);

    // Early return AFTER all hooks
    if (isLoading) {
        return <LoadingComponent
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '50vh',
                backgroundColor: '#f9f9f9',
            }}
        />;
    }

  return (
    <div className='container' style={{marginBottom:'15px'}}>
        <div>
          <SectionHeading tag="h1" title="Explore our All Products" subtitle=" Discover the artistry and elegance of our latest collection, where timeless design meets modern craftsmanship. Every piece tells a story of quality and style."/>
            <div className="products_grid" ref={productRef}>
                {product.length ? (
                    product.map((item, index) => (
                    <AllProductItem
                        key={index}
                        _id={item._id}
                        slug={item.slug}
                        images={item.imageUrl}
                        title={item.title}
                        price={item.price}
                        imageType={item.media?.[0]?.type}
                    />
                    ))
                ) : (
                    <p>No products found for "{search}"</p>
                )}
            </div>
        </div>
    </div>
  )
}

export default AllProducts